import Autocomplete, { Option as _Option } from "./Autocomplete";

export default Autocomplete;

export type Option = _Option;
